import * as React from 'react';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { StepsWrapper, Step } from '../../uiComponents/Steps';
import { Konkurrence } from '../../models/Konkurrence';
import { Tilmelding } from '../../models/Tilmelding';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import Moment from 'react-moment';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { LinkSecondaryButton, LinkPrimaryButton } from '../../uiComponents/input/Buttons';
import { ImageFromBlob } from '../../uiComponents/layout/ImageFromBlob';
import { getSite } from '../../infrastructure/site/SiteProvider';

export interface TilmeldingBekraeftProps {
    konkurrence: Konkurrence;
    tilmeldtInstitution: string;
    laererNavn: string;
    tilmelding: Tilmelding;
    opgavepakkeTitel: string;
    venteliste: boolean;
}

class TilmeldingBekraeft extends React.Component<TilmeldingBekraeftProps, any> {
    render() {
        const laerere = this.props.tilmelding.inviteredeLaerere.map((e, i) =>
            <li key={i}>{e.navn + ', ' + this.props.tilmeldtInstitution + ' (inviteret)'}</li>
        );
        const ansvarligLaerer = <li>{this.props.laererNavn}, {this.props.tilmeldtInstitution} (ansvarlig)</li>;

        laerere.splice(0, 0, ansvarligLaerer);

        let header = 'Tillykke! ' + this.props.tilmelding.hold.navn + ' ' + this.props.tilmeldtInstitution + ' er nu tilmeldt ' + this.props.konkurrence.titel;
        if (this.props.venteliste) {
            header = 'Tillykke! ' + this.props.tilmelding.hold.navn + ' ' + this.props.tilmeldtInstitution + ' er nu på venteliste til ' + this.props.konkurrence.titel;
        }

        return (
            <div id='tilmelding-bekraeftelse'>
                <ContentWrapper>
                    <StepsWrapper>
                        <Step href='#' label='1' state='done'>
                            Login
                    </Step>
                        <Step href='#' label='2' state='done'>
                            Vælg konkurrence
                    </Step>
                        <Step href='#' label='3' state='done'>
                            Tilmeld hold
                    </Step>
                        <Step href='#' label='4' state='active'>
                            Bekræft
                    </Step>
                    </StepsWrapper>
                    <SectionGroup>
                        <Section>                            
                            <h1>{header}</h1>
                        </Section>
                        <Section>
                            <div className='konkurrence-summary'>
                                <Row>
                                    <Col md={3} className='card-image-wrapper'>
                                        <ImageFromBlob id={this.props.konkurrence.billedId} />
                                    </Col>
                                    <Col md={9}>
                                        <h2><Moment format='DD.MM.YY'>{String(this.props.konkurrence.startdato)}</Moment> - {this.props.konkurrence.titel}</h2>
                                        <p>{this.props.konkurrence.afviklingssted}</p>
                                        <p>{this.props.konkurrence.adresse} </p>
                                        <p>{this.props.konkurrence.postnummer} {this.props.konkurrence.bynavn}</p>
                                    </Col>
                                </Row>
                            </div>
                        </Section>
                        <Section>
                            <Row>
                                <Col md={3}><h4>Konkurrence</h4></Col>
                                <Col md={9}>{this.props.opgavepakkeTitel}</Col>
                            </Row>
                            <div className='laerere-section'>
                                <Row>
                                    <Col md={3}><h4>Lærer</h4></Col>
                                    <Col md={9}>
                                        <ul>
                                            {laerere}
                                        </ul>
                                        <p className='laerere'>
                                            Lærere kan logge på {getSite().navn} med deres Unilogin (efter log in kan flere lærere gives adgang, hvis det bliver nødvendigt).
                                        </p>
                                    </Col>
                                </Row>
                            </div>

                        </Section>
                        <Section>
                            <Row>
                                <Col md={3}><h4>Elever</h4></Col>
                                <Col md={9}>Eleverne i {this.props.tilmelding.hold.navn} får adgang til opgaver og logbog via deres Unilogin.</Col>
                            </Row>
                        </Section>
                        <Row>
                            <Col md={6} mdOffset={3} className='centered kviterring-invitationer'>
                                <h4>Tak for din tilmelding. Der er sendt en kvittering til din e-mail. Hvis du har inviteret en eller flere kollegaer, så er der sendt en invitation til dem.</h4>
                            </Col>
                        </Row>
                        <ButtonSection>
                            <LinkSecondaryButton className='spacer' text='Tilmeld flere hold' url='/tilmelding/vaelg-konkurrence/' />
                            <LinkPrimaryButton className='spacer' text='Gå til min side' url='/' />
                        </ButtonSection>
                    </SectionGroup>
                </ContentWrapper>
            </div>
        );
    }
}

export default TilmeldingBekraeft;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldingBekraeftelse.tsx